<template>
  <div class="operation-log">
    <el-form
      :inline="true"
      :model="searchParams"
      class="demo-form-inline"
    >
      <el-form-item :label="$t('lang.Command Number')">
        <el-input v-model="searchParams.number"
                  :placeholder="$t('lang.Please enter command number')"
                  clearable maxlength="50"/>
      </el-form-item>
      <el-form-item :label="$t('lang.Operating Account')">
        <el-input v-model="searchParams.operaterInfo"
                  :placeholder="$t('lang.Please enter operating account')"
                  clearable maxlength="50"/>
      </el-form-item>
      <el-form-item :label="$t('lang.Reason For Delivery')">
        <el-select v-model="searchParams.operaterRole" placeholder="" clearable>
          <el-option
            v-for="item in operaterRoleList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('lang.State')">
        <el-select v-model="searchParams.status" placeholder="" clearable>
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('lang.Operation Type')">
        <el-select v-model="searchParams.operateType" placeholder="" clearable>
          <el-option
            v-for="item in operateTypeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('lang.Creation time')">
        <el-date-picker
          v-model="timeArr"
          type="datetimerange"
          range-separator="-"
          value-format="timestamp"
          :start-placeholder="$t('lang.start time')"
          :end-placeholder="$t('lang.end time')">
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="handleCurrentChange()">{{ $t('lang.Inquire') }}</el-button>
    </el-form>
    <el-table
      :data="dataList"
      style="width: 100%;margin-bottom: 20px;"
      class="table-custom"
    >
      <el-table-column prop="number" :label="$t('lang.Command Number')" width="200"></el-table-column>
      <el-table-column prop="number" :label="$t('lang.Reason For Delivery')" width="200"></el-table-column>
      <el-table-column prop="number" :label="$t('lang.Operating Account')" width="200"></el-table-column>
      <el-table-column prop="number" :label="$t('lang.Operation Type')" width="200"></el-table-column>
      <el-table-column prop="number" :label="$t('lang.Creation time')" width="200"></el-table-column>
      <el-table-column prop="number" :label="$t('lang.Execution Time')" width="200"></el-table-column>
      <el-table-column prop="number" :label="$t('lang.Update Time')" width="200"></el-table-column>
      <el-table-column prop="number" :label="$t('lang.State')" ></el-table-column>
    </el-table>
    <div class="dfcc">
      <el-pagination
        :current-page="beginIndex + 1"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10,20, 30, 40,50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Utils from '../../utils/utils';
import {queryOperationMaintenanceRecord} from '../../api/deviceManagement';

export default {
  name: 'electricBicycleOperationLog',
  props: {
    editData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      //查询参数
      searchParams: {
        //操作记录编号
        number: '',
        //操作账号
        operaterInfo: '',
        //下发原因
        operaterRole: '',
        //状态
        status: '',
        //操作类型
        operateType: '',
        beginTime: '',
        endTime: '',
        //设备编号
        deviceId: ''
      },
      pageSize: 10,
      beginIndex: 0,
      total: 0,
      dataList: [],
      //可以选择的下发原因列表
      operaterRoleList: [
        {
          id: '',
          text: this.$t('lang.All')
        },
        {
          id: '2',
          text: this.$t('lang.User operation')
        },
        {
          id: '1',
          text: this.$t('lang.Admin operation')
        },
        {
          id: '0',
          text: this.$t('lang.System operation')
        },
      ],
      statusList: [
        {
          id: '',
          text: this.$t('lang.All')
        },
        {
          id: '2',
          text: this.$t('lang.Success')
        },
        {
          id: '3',
          text: this.$t('lang.Failure')
        },
        {
          id: '1',
          text: this.$t('lang.Processing')
        },
      ],
      operateTypeList: [
        {
          id: '',
          text: this.$t('lang.All')
        },
        {
          id: '1000',
          text: this.$t('lang.Speed Limit Gear setting')
        },
        {
          id: '2000',
          text: this.$t('lang.Started')
        },
        {
          id: '2001',
          text: this.$t('lang.Locked')
        },
        {
          id: '2002',
          text: this.$t('lang.Wheel locked')
        },
        {
          id: '2003',
          text: this.$t('lang.Wheel unlocked')
        },
        {
          id: '2004',
          text: this.$t('lang.Restart ECU')
        },
        {
          id: '2005',
          text: this.$t('lang.Backseat locked')
        },
        {
          id: '2006',
          text: this.$t('lang.Charge locked')
        },
        {
          id: '2007',
          text: this.$t('lang.Charge unlocked')
        },
        {
          id: '2008',
          text: this.$t('lang.Discharge locked')
        },
        {
          id: '2009',
          text: this.$t('lang.Discharge unlocked')
        }
      ]
    }
  },
  computed: {
    timeArr: {
      set(e) {
        if(e && e.length) {
          this.searchParams.beginTime = e[0]
          this.searchParams.endTime = e[1]
        } else {
          this.searchParams.beginTime =''
          this.searchParams.endTime = ''
        }
        console.log(this.searchParams)
      },
      get() {
        if(this.searchParams.beginTime && this.searchParams.endTime) {
          return [this.searchParams.beginTime, this.searchParams.endTime]
        } else {
          return []
        }
      }
    }
  },
  watch: {
    editData: {
      handler() {
        this.searchParams.deviceId = this.editData.udid || this.searchParams.deviceId
        this.handleCurrentChange()
      },
      deep: true,
    },
  },
  mounted() {
    this.searchParams.beginTime = new Date(Utils.getCurrentDate() + ' 00:00').getTime();
    this.searchParams.endTime = new Date(Utils.getCurrentDate() + ' 23:59').getTime();
  },
  methods: {
    /**
     * 查询操作记录
     * @return {Promise<void>}
     */
    async queryOperationMaintenanceRecord() {
      const params = {
        deviceType: '7',
        ...this.searchParams,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      }
      const res = await queryOperationMaintenanceRecord(params)
      this.dataList = res.ldata;
      this.total = res.mdata.total;
    },
    /**
     * 个数改变
     * @param pageSize
     */
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.queryOperationMaintenanceRecord();
    },
    /**
     * 页面跳转
     * @param page
     */
    handleCurrentChange(page = 1) {
      this.beginIndex = page - 1;
      this.queryOperationMaintenanceRecord();
    },

  }
}
</script>

<style scoped lang="scss">
.list {
  //width: 1180px;
  line-height: 30px;
  margin: 20px 30px 10px;

  .name-label {
    float: left;
  }

  .value-label {
    display: inline-block;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}
.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }
}
.mt4 {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/electricBicycleOperationLog.vue